class TSMainOffer extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
  }

  connectedCallback() {
    this.productVariants = JSON.parse(this.querySelector("[data-dynamic-variants]").textContent);
    this.cart = document.querySelector("cart-drawer");

    this.querySelector('[id^="TSOfferForm-"]')?.addEventListener("submit", this.onFormSubmit.bind(this));
    this.querySelector('[id^="TSOfferOptions-"]')?.addEventListener("change", this.onVariantChange.bind(this));
    this.querySelector('[id^="TSOfferSubscription-"]')?.addEventListener("change", this.onSubscriptionChange.bind(this));
    this.querySelector('[id^="TSOfferSubscription-"]')?.addEventListener("submit", this.onFormSubmit.bind(this));

    this.initGallery();
    this.initClickListeners();
  }

  onVariantChange() {
    if (this.isLoading) return;

    this.toggleLoading();

    const searchParams = new URLSearchParams(window.location.search);
    let selectedValuesLabel = '';
    let variantId = 0;

    [1, 2, 3].forEach(option => {
      if (this.querySelector(`[data-option="${option}"]`)) {
        if (this.querySelector(`[data-option="${option}"] input:checked`)) {
          selectedValuesLabel += ' / ' + this.querySelector(`[data-option="${option}"] input:checked`).value;
        } else {
          selectedValuesLabel += ' / ' + this.querySelector(`[data-option="${option}"] input`).value;
        }
      }
    });

    this.productVariants.forEach(variant => {
      if (variant.title === selectedValuesLabel.slice(3)) {
        if (this.querySelector("input[name='id']")) {
          variantId = variant.id;
          this.querySelector("input[name='id']").value = variant.id;
        }
        searchParams.set('variant', variant.id);
      }
    })

    const newProductUrl = window.location.origin + window.location.pathname + `?${searchParams.toString()}`;
    window.history.replaceState({}, '', newProductUrl);

    fetch(newProductUrl)
      .then(res => res.text())
      .then(body => {
        const html = new DOMParser().parseFromString(body, "text/html");

        this.renderContent(html);
        document.dispatchEvent(new CustomEvent('offer:variant-change', {
          detail: {
            variant: variantId
          }
        }));
      })
      .catch(error => this.showError(error))
      .finally(() => this.toggleLoading())
  }

  onFormSubmit(event = false) {
    if (event) event.preventDefault();
    console.log("EG CHECK");
    

    if (this.isLoading) return;

    const form = event?.target?.closest("form") || this;

    const sellingPlanValue = form.querySelector("[name='selling_plan']").value;
    const item = {
      id: parseInt(form.querySelector("[name='id']").value),
      quantity: parseInt(form.querySelector("[name='quantity']").value),
    };

    if (sellingPlanValue) {
      item.selling_plan = parseInt(sellingPlanValue);
    }

    const cartData = {
      items: [item]
    };

    if (this.cart) {
      cartData['sections'] = this.cart.getSectionsToRender().map((section) => section.id)
      cartData['sections_url'] = window.location.pathname
    }
    
    this.addToCart(cartData);
  }

  onSubscriptionChange(event) {
    const form = event.target.closest("form");
    const sellingPlanInput = form.querySelector('[name="selling_plan"]');

    sellingPlanInput.value = event.target.value;
  }

  addToCart(data) {
    if (!data) return;

    this.toggleLoading();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(response => {
        if (!response.items) {
          const error = new Error(response.description);
          throw error;
        } else {
          this.toggleLoading();

          if (this.cart) {
            this.cart.renderContents(response);
            this.cart.classList.remove("is-empty");
            this.cart.open();
          }
        }
      })
      .catch(error => this.showError(error))
      .finally(() => this.toggleLoading(true));
  }

  renderContent(html) {
    console.log("CHECK");
    const section = html.querySelector(`[data-section="${this.dataset.section}"]`);
    const selectors = [
      '[id^="TSOfferGallery-"]',
      '[id^="TSOfferGalleryNav-"]',
      '[id^="TSOfferOptions-"]',
      '[id^="TSOfferSubmit-"]',
      '[id^="TSOfferSubscription-"]'
    ];

    console.log(selectors);

    selectors.forEach(selector => {
      const currentSelectors = this.querySelectorAll(selector);
      const newSelectors = section.querySelectorAll(selector);

      if (currentSelectors.length > 0 && currentSelectors.length == newSelectors.length) {
        currentSelectors.forEach((currentSelector, i) => {
          currentSelector.innerHTML = newSelectors[i].innerHTML;
        })
      }
    });

    if (this.querySelector('[id^="TSOfferSubmit-"]')) {
      const currentButton = this.querySelector('[id^="TSOfferSubmit-"]');
      const newButton = section.querySelector('[id^="TSOfferSubmit-"]');
      currentButton.toggleAttribute("disabled", newButton.disabled);
    }
  }

  initGallery() {
    this.gallery = this.querySelector('[id^="TSOfferGallery-"]');
    this.navGallery = this.querySelector('[id^="TSOfferGalleryNav-"]');

    this.gallerySlide = 1;

    this.gallery.addEventListener('scroll', () => {
      const items = this.gallery.querySelectorAll('li');
      const scrollLeft = this.gallery.scrollLeft;
      const blockWidth = items[0]?.offsetWidth ?? 0;
      const gap = 12;

      this.gallerySlide = Math.round(scrollLeft / (blockWidth + gap)) + 1;

      items.forEach((item, index) => {
        if (index == (this.gallerySlide - 1)) {
          item.querySelector("video")?.play();
        } else {
          item.querySelector("video")?.pause();
        }
      })

      this.navGallery.querySelectorAll("li").forEach(slide => {
        slide.classList.toggle("active", slide.dataset.slide == this.gallerySlide);
      })
    });
  }

  initClickListeners() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "prev-slide":
            if (this.gallerySlide > 1) {
              this.scrollToSlide(this.gallery, this.gallerySlide - 1);
            }
            break;
          case "change-slide":
            this.scrollToSlide(this.gallery, parseInt(e.target.dataset.slide));
            break;
          case "next-slide":
            if (this.gallerySlide < this.gallery.querySelectorAll("li").length) {
              this.scrollToSlide(this.gallery, this.gallerySlide + 1);
            }
            break;
          case "toggle-disclosure":
            const disclosureContent = e.target.nextElementSibling;

            e.target.classList.toggle("open");
            disclosureContent.style.maxHeight = e.target.classList.contains("open") ? disclosureContent.scrollHeight + "px" : null;
            break;
          case "add-upsell":
            if (!this.isLoading) {
              const upsellCartData = {
                items: [
                  {
                    id: parseInt(e.target.dataset.variant),
                    quantity: 1
                  }
                ]
              };

              if (this.cart) {
                upsellCartData['sections'] = this.cart.getSectionsToRender().map((section) => section.id)
                upsellCartData['sections_url'] = window.location.pathname
              }
              this.addToCart(upsellCartData);
            }
            break;
        }
      }
    })
  }

  scrollToSlide(slider, index) {
    if (!slider) return;

    slider.scrollTo({
      left: slider.querySelector(`li:nth-child(${index})`).offsetLeft,
      behavior: 'smooth'
    });
  }

  showError(error) {
    console.error(error);

    if (!this.querySelector("[product-notification]")) return;

    const messageBlock = this.querySelector("[product-notification]");

    messageBlock.innerText = error.message;
    setTimeout(() => { messageBlock.innerText = '' }, 5000);
    messageBlock.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  toggleLoading(turnOff = false) {
    this.isLoading = !this.isLoading;
    if (turnOff) this.isLoading = false;
    this.classList.toggle("loading", this.isLoading);
  }
}

customElements.define("ts-main-offer", TSMainOffer);